import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { UpgradeRecommendationApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = UpgradeRecommendationApiClient;
export const UpgradeRecommendationExtension = createModuleExtension({
  extensionName: 'upgradeRecommendationExtension',
  Provider,
  SDK: {
    upgradeRecommendationApiClient: client
  }
});
//# sourceMappingURL=upgrade-recommendation.extension.js.map